import { render, staticRenderFns } from "./KnivesetConfigurationForm.vue?vue&type=template&id=88e2cc36&"
import script from "./KnivesetConfigurationForm.vue?vue&type=script&lang=ts&"
export * from "./KnivesetConfigurationForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports